import Conf from 'ui-config'
import axios from 'axios'

export const Scopes = {
  getScopes: async function (params, clusterId) {
    return await axios(Conf.HOST + Conf.LC_IP + '/lc/mgmt/cluster/' + (typeof clusterId !== 'undefined' ? clusterId + '/' : '') + 'scope/list', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        SSID: params.ssid,
      },
      data: params
    })
  },
  getEnabledScopes: async function (params, clusterId) {
    return await axios(Conf.HOST + Conf.LC_IP + '/lc/mgmt/cluster/' + (typeof clusterId !== 'undefined' ? clusterId + '/' : '') + 'scope/list?is_enabled=enabled&pageno=' + params.pageno + '&pagesize=' + params.size, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        SSID: params.ssid,
      },
    })
  },
  getDisabledScopes: async function (params, clusterId) {
    return await axios(Conf.HOST + Conf.LC_IP + '/lc/mgmt/cluster/' + (typeof clusterId !== 'undefined' ? clusterId + '/' : '') + 'scope/list?is_enabled=disabled&pageno=' + params.pageno + '&pagesize=' + params.size, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        SSID: params.ssid,
      },
    })
  },
  getUserAccessDetails: function (params, ssid) {
    return axios.get(Conf.HOST + Conf.LC_IP + '/lc/users/access-details', {
      headers: {
        SSID: ssid,
      },
    })
  },

  SubmitEula: async function (ssid) {
    return await axios(Conf.HOST + Conf.LC_IP + '/lc/mgmt/users/accept-eula', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        SSID: ssid,
      },
    })
  },

  saveScope: async function (params, ssid) {
    return await axios(Conf.HOST + Conf.CORE_IP3 + '/' + params.clusterId + '/mgmt/scope/', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        SSID: ssid,
      },
      data: params,
    })
  },
  changeStatus: async function (params) {
    return await axios(Conf.HOST + Conf.CORE_IP3 + '/' + params.clusterId + '/mgmt/scope/' + params.scope_id + '/status', {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        SSID: params.ssid,
      },
      data: { is_enabled: params.is_enabled },
    })
  },
  deleteScope: async function (params) {
    return await axios(Conf.HOST + Conf.CORE_IP3 + '/' + params.clusterId + '/mgmt/scope', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        SSID: params.ssid,
      },
      data: params,
    })
  },
}
export default Scopes
